/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // MOBILE: con el dedo apoyado sobre la imagen de una tarjeta (tap sostenido o scroll)
  // se muestra la segunda imagen con la animación del hover de desktop; al soltar,
  // vuelve a la principal. Estilos en assets/custom.css.
  var ACTIVE_CLASS = 'product-grid-item__image--touch-active';
  var CARD = '.product-grid-item__image';
  var HOLD_MS = 400; // desde aquí el tap cuenta como sostenido y no abre el producto
  var activeCard = null;
  var touchStart = 0;
  var suppressClick = false;

  function release() {
    if (activeCard) activeCard.classList.remove(ACTIVE_CLASS);
    activeCard = null;
  }

  document.addEventListener('touchstart', function (event) {
    release();
    suppressClick = false;
    if (event.touches.length > 1) return; // pinch-zoom

    var card = event.target.closest(CARD);
    if (!card || !card.querySelector('.product__media__hover')) return;

    activeCard = card;
    touchStart = Date.now();
    card.classList.add(ACTIVE_CLASS);
  }, { passive: true });

  document.addEventListener('touchend', function () {
    if (activeCard) suppressClick = Date.now() - touchStart >= HOLD_MS;
    release();
  }, { passive: true });

  document.addEventListener('touchcancel', release, { passive: true });

  // Tap sostenido: al soltar no navegar al producto
  document.addEventListener('click', function (event) {
    if (suppressClick && event.target.closest(CARD)) {
      event.preventDefault();
      event.stopPropagation();
    }
    suppressClick = false;
  }, true);

  // Android: sin menú contextual del enlace mientras se mantiene el dedo
  document.addEventListener('contextmenu', function (event) {
    if (activeCard) event.preventDefault();
  });







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
